// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"cccc3a2f","364":"041eaa13","628":"ccb5d767","642":"a6ceac0a","695":"9089f536"}[chunkId] + ".chunk.js";
};